import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Send, CheckCircle2, Share2 } from "lucide-react";
import { motion } from "framer-motion";
import { useT } from "../lib/prefs";

const TG = "https://t.me/rahsiatradingsecret";

const markJoined = (token) => {
  if (!token) return;
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bookings/join`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
    keepalive: true,
  }).catch(() => {});
};

export const SuccessModal = ({ open, onOpenChange, joinToken, refCode }) => {
  const t = useT();
  const shareUrl = `${window.location.origin}/${refCode ? `?ref=${refCode}` : ""}`;
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="booking-success-modal" className="bg-[#140A2C] border border-violet-400/30 text-white rounded-3xl max-w-md p-8 sm:p-10 shadow-[0_0_80px_rgba(124,58,237,0.45)]">
      <motion.div initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 200, damping: 14 }} className="w-16 h-16 rounded-full bg-violet-500/20 border border-violet-300/40 grid place-items-center mb-6">
        <CheckCircle2 className="w-8 h-8 text-violet-200" />
      </motion.div>
      <DialogTitle className="font-display uppercase text-2xl font-black">{t.successTitle}</DialogTitle>
      <DialogDescription data-testid="success-message" className="text-violet-100/85 text-base leading-relaxed mt-2">
        {t.successPre}{" "}
        <a href={TG} target="_blank" rel="noopener noreferrer" onClick={() => markJoined(joinToken)} data-testid="success-inline-telegram-link" className="text-violet-300 underline underline-offset-4">t.me/rahsiatradingsecret</a>{" "}
        {t.successPost}
      </DialogDescription>
      <a
        href={TG}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => markJoined(joinToken)}
        data-testid="join-telegram-btn"
        className="btn-neon mt-8 w-full rounded-full py-4 font-semibold inline-flex items-center justify-center gap-3"
      >
        <Send className="w-5 h-5" /> {t.joinTelegram}
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${t.shareText} ${shareUrl}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp-btn"
        className="mt-3 w-full rounded-full py-3.5 font-semibold inline-flex items-center justify-center gap-3 border border-emerald-400/50 text-emerald-300 hover:bg-emerald-500/10 transition-colors duration-300"
      >
        <Share2 className="w-5 h-5" /> {t.shareFriend}
      </a>
    </DialogContent>
  </Dialog>
  );
};
